/* 多语言input的格式 */
const multiInputFormat = {
  'zh_CN': '',
  'zh_HK': '',
  'en': ''
} //

/* 性别选项 */
const genderOptions = [
  {
    value: 'man',
    label: '男'
  },
  {
    value: 'woman',
    label: '女'
  },
  {
    value: 'secret',
    label: '我不想回答'
  }
]

/* 购买意愿选项(多语言) */
const isBuyOptions = {
  'en': [
    {
      value: 'isBuy',
      label: '想好要买,买了'
    },
    {
      value: 'wantBuyNotBuy',
      label: '想好要买,没买'
    },
    {
      value: 'notWantButBuy',
      label: '没想买,买了'
    },
    {
      value: 'notBuy',
      label: '没想买,没买'
    }
  ],
  'zh_CN': [
    {
      value: 'isBuy',
      label: '想好要买,买了'
    },
    {
      value: 'wantBuyNotBuy',
      label: '想好要买,没买'
    },
    {
      value: 'notWantButBuy',
      label: '没想买,买了'
    },
    {
      value: 'notBuy',
      label: '没想买,没买'
    }
  ],
  'zh_HK': [
    {
      value: 'isBuy',
      label: '想好要買，買了'
    },
    {
      value: 'wantBuyNotBuy',
      label: '想好要買，沒買'
    },
    {
      value: 'notWantButBuy',
      label: '沒想買，買了'
    },
    {
      value: 'notBuy',
      label: '沒想買，沒買'
    }
  ]
}

/* 年龄选项 */
const ageOptions = {
  'en': [
    {
      value: '18-',
      label: '18以下'
    },
    {
      value: '18-25',
      label: '18-25'
    },
    {
      value: '26-35',
      label: '26-35'
    },
    {
      value: '36-45',
      label: '36-45'
    },
    {
      value: '46-55',
      label: '46-55'
    },
    {
      value: '56-65',
      label: '56-65'
    },
    {
      value: '66+',
      label: '66岁及以上'
    },
    {
      value: 'secret',
      label: '我不想回答'
    }
  ],
  'zh_CN': [
    {
      value: '18-',
      label: '18以下'
    },
    {
      value: '18-25',
      label: '18-25'
    },
    {
      value: '26-35',
      label: '26-35'
    },
    {
      value: '36-45',
      label: '36-45'
    },
    {
      value: '46-55',
      label: '46-55'
    },
    {
      value: '56-65',
      label: '56-65'
    },
    {
      value: '66+',
      label: '66岁及以上'
    },
    {
      value: 'secret',
      label: '我不想回答'
    }
  ],
  'zh_HK': [
    {
      value: '18-',
      label: '18以下'
    },
    {
      value: '18-25',
      label: '18-25'
    },
    {
      value: '26-35',
      label: '26-35'
    },
    {
      value: '36-45',
      label: '36-45'
    },
    {
      value: '46-55',
      label: '46-55'
    },
    {
      value: '56-65',
      label: '56-65'
    },
    {
      value: '66+',
      label: '66嵗及以上'
    },
    {
      value: 'secret',
      label: '我不想回答'
    }
  ],
};

/* hubdoor选项 */
// const hubDoorOptions = [
//   {
//     label: '是',
//     value: true
//   },
//   {
//     label: '否',
//     value: false
//   }
// ]

/* 试穿选项(多语言) */
const tryOnOptions = {
  'en': [
    {
      value: 'shoe',
      label: '试穿了鞋子'
    },
    {
      value: 'clothes',
      label: '试穿了服装'
    },
    {
      value: 'equip',
      label: '试穿了装备'
    },
    {
      value: 'notTry',
      label: '未试穿'
    }
  ],
  'zh_CN': [
    {
      value: 'shoe',
      label: '试穿了鞋子'
    },
    {
      value: 'clothes',
      label: '试穿了服装'
    },
    {
      value: 'equip',
      label: '试穿了装备'
    },
    {
      value: 'notTry',
      label: '未试穿'
    }
  ],
  'zh_HK': [
    {
      value: 'shoe',
      label: '試穿了鞋子'
    },
    {
      value: 'clothes',
      label: '試穿了服裝'
    },
    {
      value: 'equip',
      label: '試穿了裝備'
    },
    {
      value: 'notTry',
      label: '未試穿'
    }
  ]
}

export { multiInputFormat, genderOptions, isBuyOptions, ageOptions, tryOnOptions }



// WEBPACK FOOTER //
// ./src/utils/global.js